/**
 * Carrossel simples baseado em scroll-snap.
 * Marca-se com [data-carousel] contendo [data-carousel-track], [data-carousel-prev], [data-carousel-next].
 */

const step = (track) => {
  const item = track.querySelector(':scope > *');
  if (!item) return track.clientWidth;
  const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
  return item.getBoundingClientRect().width + gap;
};

const updateButtons = (track, prev, next) => {
  const max = track.scrollWidth - track.clientWidth - 1;
  if (prev) prev.disabled = track.scrollLeft <= 0;
  if (next) next.disabled = track.scrollLeft >= max;
};

const initCarousel = (root) => {
  const track = root.querySelector('[data-carousel-track]');
  if (!track) return;

  const prev = root.querySelector('[data-carousel-prev]');
  const next = root.querySelector('[data-carousel-next]');

  prev?.addEventListener('click', () => track.scrollBy({ left: -step(track), behavior: 'smooth' }));
  next?.addEventListener('click', () => track.scrollBy({ left: step(track), behavior: 'smooth' }));

  const sync = () => updateButtons(track, prev, next);
  track.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  sync();
};

export const initCarousels = () => {
  document.querySelectorAll('[data-carousel]').forEach(initCarousel);
};
